module.exports = __webpack_public_path__ + "img/thank-quick.e88956b7.jpg";